import React, { useEffect, useState } from "react";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useAuth } from "../../../AuthProvider";
import { Select, InputLabel, FormControl, MenuItem, TableContainer,
  TableBody, TableHead, TableRow, TableCell, Card,  Dialog,
  DialogTitle,
  DialogContent, Grid,
  TextField,
  DialogActions,
  Table,  Paper, Box,Typography, CircularProgress ,Button} from "@mui/material";
import { useParams,useNavigate } from "react-router-dom";
import {IconButton} from '@mui/material'
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import { borderRadius } from "@mui/system";
import { GlobalStyles } from "@mui/system";
import Swal from "sweetalert2";

import DeleteIcon from '@mui/icons-material/Delete';
import RemoveIcon from "@mui/icons-material/Remove";
import AddIcon from "@mui/icons-material/Add";

const baseUrl = process.env.REACT_APP_API_BASE_URL;

const AllStockItemsListForStudents = () => {
     const navigate = useNavigate();
     const student = JSON.parse(sessionStorage.getItem("studentName"));
  const [items, setItems] = useState([]);
  const [saveditems, setSavedItems] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [itemsloading, setItemsLoading] = useState(false);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [submitFinalLoading, setSubmitFinalLoading] = useState(false);
  const { studentId } = useParams();
  const { oId, userId, role ,pId} = useAuth();
  const [users, setUsers] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState("");
  const isPrincipal = role?.startsWith("PRINCIPAL") || false;
  const UserId = userId || selectedUsers;
  const filteredItems = items.filter((item) => item.qty > 0);

  // const [selectedRow, setSelectedRow] = useState(null); // To store the row to edit
  const [isDialogOpen, setDialogOpen] = useState(false); // Dialog open state
  const [dialogbtnloading, setDialogbtnloading] = useState(false); // State for loading

const [selectedRow, setSelectedRow] = useState({});




  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const response = await fetch(
          `${baseUrl}/api/principal/getAllUserIdsAndNames/STORE_DEPARTMENT/${oId}/${pId}`
        );
        const data = await response.json();
        setUsers(data);
        if (data.length > 0) {
          setSelectedUsers(data[0].userId);
        }
      } catch (error) {
        console.error("Error fetching users:", error);
      }
    };
    fetchUsers();
  }, []);






  useEffect(() => {
    fetchItems();
  }, []);

  const fetchItems = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${baseUrl}/api/itemstable/pr/getAllItems/${oId}/${pId}`);
      setItems(response.data);
    } catch (error) {
      // toast.error("Failed to fetch items.");
      console.log("Failed to fetch  items.")
    } finally {
      setLoading(false);
    }
  };

  const fetchSavedItems = async () => {
    if(!studentId) return; // Prevent fetching if studentId is not available
    setItemsLoading(true);
    try {
      const response = await axios.get(`${baseUrl}/api/cartAddItems/getAllItemsByStudent/${studentId}/${oId}`);
      setSavedItems(response.data);
    } catch (error) {
      // toast.error("Failed to fetch Saved items.");
      console.log("Failed to fetch Saved items.")
    } finally {
      setItemsLoading(false);
    }
  };

  useEffect(() => {
    fetchSavedItems();
  }, []);

  const handleCheckboxChange = (item) => {
    const exists = selectedItems.some((i) => i.itId === item.itId);
    if (exists) {
      setSelectedItems(selectedItems.filter((i) => i.itId !== item.itId));
    } else {
      setSelectedItems([...selectedItems, item]);
    }
  };



 



  const handleSubmit = async () => {
    if (selectedItems.length === 0) {
      toast.warn("Please select at least one item.");
      return;
    }
  
    setSubmitLoading(true);
    try {
      const response = await fetch(
        `${baseUrl}/api/cartAddItems/saveCartItems/${UserId}/${studentId}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(selectedItems),
        }
      );
  
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
  
      toast.success("Items Saved successfully!");
      fetchSavedItems();
      setSelectedItems([]);
    } catch (error) {
      toast.error("Failed to submit items.");
    } finally {
      setSubmitLoading(false);
    }
  };






  const handleEditClick = (item) => {
    setSelectedRow(item); // Set the selected row
    setDialogOpen(true); // Open the dialog
  };
  const handleDialogClose = () => {
    setDialogOpen(false); // Close the dialog
    setSelectedRow(null); // Clear the selected row
  };

  // const handleSaveChanges = async () => {
   
  //   setDialogbtnloading(true); // Start loading
  //   try {
  //     const formData = new FormData();
  
  //     // Append each key-value pair to FormData
  //     Object.keys(selectedRow).forEach((key) => {
  //       if (selectedRow[key] !== null && selectedRow[key] !== undefined) {
  //         formData.append(key, selectedRow[key]);
  //       }
  //     });
  
  //     // Ensure the correct ID is used
  //     const response = await fetch(
  //       `${baseUrl}/api/cartAddItems/update/${selectedRow.itId}/${oId}/${pId}`,
  //       {
  //         method: "PATCH",
  //         body: formData,
  //       }
  //     );
  
  //     const responseData = await response.text();
  
  //     if (response.ok) {
  //       toast.success(`Quantity "${selectedRow.qty}" Updated successfully!`);
  
  //       fetchSavedItems(); // Refresh the saved items after update
    
  //       handleDialogClose();
  //     }else{
  //       toast.error(`${responseData}` || "Failed to update item.");
  //     }
  
     
  //   } catch (error) {
  //     console.error("Error updating details:", error);
  //     toast.error(`Error updating details: ${error}`);
  //   }finally {
  //     setDialogbtnloading(false); // Stop loading
  //   }
  // };


const handleSaveChanges = async (currentItem) => {
  const itemToSave = selectedRow?.itId === currentItem.itId ? selectedRow : { ...currentItem };
  if (!itemToSave.itId) {
    toast.error("Cannot save: missing item ID.");
    return;
  }

  setDialogbtnloading(true);
  try {
    const formData = new FormData();
    Object.keys(itemToSave).forEach((key) => {
      if (itemToSave[key] !== null && itemToSave[key] !== undefined) {
        formData.append(key, itemToSave[key]);
      }
    });

    const response = await fetch(
      `${baseUrl}/api/cartAddItems/update/${itemToSave.itId}/${oId}/${pId}`,
      {
        method: "PATCH",
        body: formData,
      }
    );

    const responseData = await response.text();

    if (response.ok) {
      toast.success(`Quantity "${itemToSave.qty}" updated successfully!`);
      fetchSavedItems();
      handleDialogClose();
    } else {
      toast.error(`${responseData}` || "Failed to update item.");
    }
  } catch (error) {
    console.error("Error updating details:", error);
    toast.error(`Error updating details: ${error}`);
  } finally {
    setDialogbtnloading(false);
  }
};




    const handleDeleteItem = async (item) => {
      if (!item.itId) {
        toast.error("Invalid item. Please select a valid item to delete.");
        return;
      }
    
      // Show SweetAlert2 confirmation
      Swal.fire({
        title: "Are you sure?",
        text: `You Want To Delete Item "${item.items}"`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: "Yes, delete it!",
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            console.log("Deleting row with ID:", item.itId);
            const response = await fetch(
              `${baseUrl}/api/cartAddItems/delete/${item.itId}/${oId}`,
              {
                method: "DELETE",
              }
            );
    
            if (!response.ok) {
              throw new Error("Failed to delete the row. Please try again.");
            }
    
            toast.success(`Item "${item.items}" Deleted successfully!`, {
              autoClose: 1000, // Closes after 1 second (1000ms)
            });
           fetchSavedItems(); // Refresh the saved items after deletion
           
          } catch (error) {
            console.error("Error deleting row:", error);
            toast.error(`Error deleting row: ${error.message}`);
          }
        }
      });
    };
  


    const handleFinalSubmit = async () => {
      if (!saveditems || saveditems.length === 0) {
        toast.warn("No items to submit.");
        return;
      }
    
      setSubmitFinalLoading(true);
      try {
        const response = await fetch(
          `${baseUrl}/api/soldItems/saveSoldItems/${UserId}/${studentId}`,
          {  
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(saveditems), // Send data here
          }
        );
    
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
    
        toast.success("Items Submitted successfully!");
        navigate("/SoldItems"); // Redirect to the desired page
      } catch (error) {
        toast.error("Failed to submit items.");
        console.error(error);
      } finally {
        setSubmitFinalLoading(false);
      }
    };
    







  
  const styles = {
    container: {
        minHeight: "80vh",
        backgroundColor: "#f3f4f6",
        // display: "flex",
        // justifyContent: "center",
        padding: "5% 10px", // equal padding left & right
        
      },
     
      
    heading: {
      fontSize: "20px",
      fontWeight: "700",
      color: "#1f2937",
      marginBottom: "20px",
      display: "flex",
      alignItems: "center",
      gap: "5px",
    },
    backArrow: {
      fontSize: "24px",
      cursor: "pointer",
      color: "#2563eb",
    },
    table: {
      width: "100%",
      borderCollapse: "collapse",
    },
    th: {
        border: "1px solid #ddd", // ✅ Full border
        padding: "5px",
        backgroundColor: "#fff9c4",
        textAlign: "center",
        fontWeight: "bold",
      },
      
      td: {
        border: "1px solid #ddd", // ✅ Full border
        padding: "8px",
        textAlign: "center",
      },
    checkbox: {
      width: "16px",
      height: "16px",
      borderRight: "1px solid #ddd",
      borderBottom: "1px solid #ddd", // ✅ Add this
      padding: "8px",
      textAlign: "center",
      cursor: "pointer",
    },
    loading: {
      textAlign: "center",
      padding: "40px",
      fontSize: "16px",
      color: "#6b7280",
    },
    button: {
      marginTop: "24px",
      padding: "12px 24px",
      backgroundColor: "#3C3972",
      color: "#fff",
      fontSize: "16px",
      border: "none",
      borderRadius: "8px",
      cursor: "pointer",
    },
    buttonDisabled: {
      backgroundColor: "#9ca3af",
      cursor: "not-allowed",
    },
  };
  

  return (
    
    <Box sx={{ mt: "5%", mr: "1%", ml: "1%" }}>
    <Card
      sx={{
        marginTop: "60px",
        width: "100%",
        borderRadius: 3,
        boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
        padding: "20px",
      }}
    >
     
        {/* Heading with arrow */}
        <div style={styles.heading}>
        <IconButton onClick={() => navigate(-1)} sx={{ color: "#2e2a54" }}>
            <KeyboardBackspaceIcon fontSize="medium" />
          </IconButton>
           <Typography variant="h5" component="h3" sx={{ fontWeight: "bold" }}>
                      { `${student?.firstName} ${student?.lastName} Stock Items`}
                    </Typography>
          {/* <span>Stock Items</span> */}
        </div>

        {/* User Select for Principal */}
        {/* {isPrincipal && (
          <FormControl variant="outlined" size="small" sx={{ minWidth: 150, marginBottom: 2 }}>
            <InputLabel>Select User</InputLabel>
            <Select
              value={selectedUsers}
              onChange={(e) => setSelectedUsers(e.target.value)}
              label="Select User"
            >
              {users.map((user) => (
                <MenuItem key={user.userId} value={user.userId}>
                  {user.userId} - {user.firstName} {user.lastName}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        )} */}


        {/* Table with conditional rendering for loading state */}
        <GlobalStyles
            styles={{
              ".custom-sidebar-scrollbar": {
                scrollbarWidth: "thin", // For Firefox
                scrollbarColor: "grey #e0e0e0",
              },
              ".custom-sidebar-scrollbar::-webkit-scrollbar": {
                width: "6px", // For WebKit-based browsers
              },
              ".custom-sidebar-scrollbar::-webkit-scrollbar-track": {
                background: "#f1f1f1", // Track color
              },
              ".custom-sidebar-scrollbar::-webkit-scrollbar-thumb": {
                backgroundColor: "grey", // Thumb color
                borderRadius: "10px",
              },
              ".custom-sidebar-scrollbar::-webkit-scrollbar-thumb:hover": {
                backgroundColor: "#555",
              },
            }}
          />
<div >


  <TableContainer  component={Paper}
            sx={{
              borderRadius: 2,
              boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
              maxHeight: "350px",
              overflow: "auto",
            }}
            className="custom-sidebar-scrollbar">
  <Table stickyHeader>
    <TableHead >
      <TableRow>
        <TableCell style={styles.th}>Select</TableCell>
        <TableCell style={styles.th}>Item</TableCell>
        <TableCell style={styles.th}>Description</TableCell>
        <TableCell style={styles.th}>Units</TableCell>
        <TableCell style={styles.th}>Qty</TableCell>
        <TableCell style={styles.th}>Price per Item</TableCell>
      </TableRow>
    </TableHead>
    <TableBody>
      {loading ? (
        <TableRow>
           <TableCell
                                colSpan={10}
                                style={{ textAlign: "center", padding: "20px" }}
                              >
                                <Box
                                  display="flex"
                                  flexDirection="column"
                                  alignItems="center"
                                >
                                  <CircularProgress />
                                  <Typography variant="body2" sx={{ mt: 1 }}>
                                    Loading Data...
                                  </Typography>
                                </Box>
                              </TableCell>
        </TableRow>
      ) : items.length === 0 ? (
        <TableRow>
          <TableCell colSpan="10" style={{ textAlign: "center"}}>
            No data available
          </TableCell>
        </TableRow>
      ) :(
        filteredItems.length === 0 ? (
          <TableRow>
            <TableCell colSpan="10" style={{ textAlign: "center" }}>
              No Data Found
            </TableCell>
          </TableRow>
        ) : (
          filteredItems.map((item) => (
            <TableRow
              key={item.itId}
              style={{
                backgroundColor: "white",
                transition: "background-color 0.3s",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = "#f5f5f5"; // Hover color
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = "white"; // Default color
              }}
            >
              <TableCell style={styles.td}>
                <input
                  type="checkbox"
                  style={styles.checkbox}
                  checked={selectedItems.some((i) => i.itId === item.itId)}
                  onChange={() => handleCheckboxChange(item)}
                />
              </TableCell>
              <TableCell style={styles.td}>{item.items}</TableCell>
              <TableCell style={styles.td}>{item.description}</TableCell>
              <TableCell style={styles.td}>{item.measureUnits}</TableCell>
              <TableCell style={styles.td}>{item.qty}</TableCell>
    
              <TableCell style={styles.td}>₹{item.priceItem}</TableCell>
              
            </TableRow>
          ))
        )
      )
      }
    </TableBody>
  </Table>
  </TableContainer>
</div>


        {/* Submit Button */}
        <div style={{ textAlign: "left" }}>
          <button
            style={{
              ...styles.button,
              ...(submitLoading ? styles.buttonDisabled : {}),
            }}
            onClick={handleSubmit}
            disabled={submitLoading}
          >
            {submitLoading ? "Adding..." : "Add Items"}
          </button>
        </div>

        {/* Toast Container */}
        <ToastContainer position="top-right" autoClose={1000} />


<div style={{ marginTop: "20px" }}>
  <Typography variant="h5" style={{textAlign:'center',fontWeight:'bold'}}> Selected Items List</Typography>
        <TableContainer  component={Paper}
            sx={{
              borderRadius: 2,
              boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
              maxHeight: "350px",
              overflow: "auto",
              marginTop: "10px",
            }}
            className="custom-sidebar-scrollbar">
  <Table stickyHeader>
    <TableHead >
      <TableRow>
        <TableCell style={styles.th}>Sl.No</TableCell>
        <TableCell style={styles.th}>Item</TableCell>
        <TableCell style={styles.th}>Description</TableCell>
        <TableCell style={styles.th}>Qty</TableCell>
        <TableCell style={styles.th}>Price Per Item</TableCell>
        <TableCell style={styles.th}>Total Amount</TableCell>
        <TableCell style={styles.th}>Action</TableCell>
      </TableRow>
    </TableHead>
    <TableBody>
      {itemsloading ? (
        <TableRow>
           <TableCell
                                colSpan={10}
                                style={{ textAlign: "center", padding: "20px" }}
                              >
                                <Box
                                  display="flex"
                                  flexDirection="column"
                                  alignItems="center"
                                >
                                  <CircularProgress />
                                  <Typography variant="body2" sx={{ mt: 1 }}>
                                    Loading Data...
                                  </Typography>
                                </Box>
                              </TableCell>
        </TableRow>
      ) : saveditems.length === 0 ? (
        <TableRow>
          <TableCell colSpan="10" style={{ textAlign: "center" }}>
            No data Found
          </TableCell>
        </TableRow>
      ) : (
        saveditems.map((item,index) => (
          <TableRow key={item.itId}
          style={{
            backgroundColor: "white",
            transition: "background-color 0.3s",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = "#f5f5f5"; // Hover color
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = "white"; // Default color
          }}
          >
            <TableCell style={styles.td}>{index+1}</TableCell>
            <TableCell style={styles.td}>{item.items}</TableCell>
            <TableCell style={styles.td}>{item.description}</TableCell>

<TableCell style={styles.td}>
  {/* <TextField
    type="number"
    variant="outlined"
    size="small"
    value={selectedRow?.itId === item.itId ? selectedRow.qty : item.qty}
    onChange={(e) => {
      const newQty = e.target.value;
      setSelectedRow({ ...item, qty: newQty });
    }}
    onBlur={() => handleSaveChanges(item)}
    onKeyDown={(e) => {
      if (e.key === "Enter") {
        e.target.blur();
      }
    }}
    inputProps={{ style: { textAlign: "center" } }}
    sx={{
      width: "110px", // increased width
      input: {
        height: "35px", // increased height
        lineHeight: "40px", // center text vertically
        color: "gray",
        backgroundColor: "transparent",
        padding: "2px",
        fontWeight: "bold",
        '&:focus': {
          color: "#000", // dark text on focus
          borderBottom: "2px solid #1976d2", // attractive blue underline on focus
          backgroundColor: "transparent", // keep background transparent on focus
        },
      },
    }}
  /> */}
  <TextField
  type="number"
  variant="outlined"
  size="small"
  value={selectedRow?.itId === item.itId ? selectedRow.qty : item.qty}
  onChange={(e) => {
    const newValue = e.target.value;

    // Allow only positive integers
    if (/^\d*$/.test(newValue)) {
      setSelectedRow({ ...item, qty: newValue });
    }
  }}
  onBlur={() => handleSaveChanges(item)}
  onKeyDown={(e) => {
    if (e.key === "Enter") {
      e.target.blur();
    }
    // prevent entering 'e', 'E', '+', '-', or '.'
    if (["e", "E", "+", "-", "."].includes(e.key)) {
      e.preventDefault();
    }
  }}
  inputProps={{
    min: 0, // stops negative input with spinner
    step: 1, // no decimals
    style: { textAlign: "center" },
  }}
  sx={{
    width: "110px",
    input: {
      height: "35px",
      lineHeight: "40px",
      color: "gray",
      backgroundColor: "transparent",
      padding: "2px",
      fontWeight: "bold",
      "&:focus": {
        color: "#000",
        borderBottom: "2px solid #1976d2",
        backgroundColor: "transparent",
      },
    },
  }}
/>

</TableCell>




  



            <TableCell style={styles.td}>₹{item.priceItem}</TableCell>
            <TableCell style={styles.td}>{item.totalAmount}</TableCell>
            

             <TableCell style={styles.td} >
                                      <IconButton
                                        aria-label="delete"
                                       onClick={() => handleDeleteItem(item)}
                                        sx={{ color: "red", padding: "2px" }}
                                      >
                                        <DeleteIcon fontSize="small" /> {/* Reduce icon size */}
                                      </IconButton>
                                    </TableCell>







          </TableRow>
        ))
      )}
    </TableBody>
  </Table>
  </TableContainer>


   {/* Final Submit Button */}
   <div style={{ textAlign: "Right" }}>
          <button
            style={{
              ...styles.button,
              ...(submitFinalLoading ? styles.buttonDisabled : {}),
            }}
            onClick={handleFinalSubmit}
            disabled={submitFinalLoading}
          >
            {submitFinalLoading ? "Buying..." : "Buy Items"}
          </button>
        </div>



  </div>








      </Card>
    </Box>
  
  );
};

export default AllStockItemsListForStudents;



 


